import React, {Fragment, useState} from 'react';
import {Box, Button, Flex, Text} from "rebass";
import {withFirebase} from "../Firebase";
import {Input} from "reakit";
import {DesktopBox, MobileBox} from "../Base";
import {MetaText} from "../Base/Text";
import moment from "moment";
import {
	AttachementSection,
	AttachmentWrapper,
	ButtonWrapper,
	CardWrapper,
	FileInputWrapper,
	Folder,
	InputWrapper,
	LaptopIcon,
	Plus,
	SendButton,
	ToolbarWrapper
} from "./InputToolbar.styles";

import FileUpload from './FileUpload'

const InputToolbar = (props) => {

	const [message, updateMessage] = useState('')
	const [fileAttachment, handleFileUpload] = useState(null)
	const [showAttachmentMenu, toggleAttachmentMenu] = useState(false)

	const handleInput = (e) => {
		updateMessage(e.target.value)
	}

	const handleSendAcceptRequest = () => {
		const {selected, profile, firebase} = props;
		if (profile.id === selected.creator_uid) {

			try {
				let chatRef = firebase.chat(selected.id);

				chatRef.update({
					last_updated: Math.floor(Date.now() / 1000),
					accepted: {status: 0, updated_at: Math.floor(Date.now() / 1000)}
				});

				this.setState({message: ''})
			} catch (error) {
				console.log(error)
			}
		}
	}

	const handleAcceptChat = async () => {

		const {profile, selected, firebase} = props;
		if (profile.id !== selected.creator_uid) {
			try {
				let chatRef = firebase.chat(selected.id);
				let studentRef = firebase.student(profile.id);
				if(selected.is_group){
					chatRef.update({
						last_updated: Math.floor(Date.now() / 1000),
						accepted: {status: 0, updated_at: Math.floor(Date.now() / 1000), members: [...selected.accepted.members, profile.id]}
					});
				} else {
					chatRef.update({
						last_updated: Math.floor(Date.now() / 1000),
						accepted: {status: 1, updated_at: Math.floor(Date.now() / 1000)}
					});
					studentRef.update({
						contacts: this.props.firebase.fieldValue.arrayUnion(selected.creator_uid)
					})
				}



			} catch (error) {
				console.log(error)
			}
		}

	};

	const handleDeclineChat = async () => {
		const {profile, firebase, selected} = props;
		if (profile.id !== selected.creator_uid) {
			try {
				let chatRef = firebase.chat(selected.id);

				if(selected.is_group){
					let acceptChatResult = await chatRef.update({
						last_updated: Math.floor(Date.now() / 1000),
						members: selected.members.filter(member => member !== profile.id).map(member => member.id),
						accepted: {status: 0, updated_at: Math.floor(Date.now() / 1000), members: selected.accepted.members}
					});
					console.log(acceptChatResult)

				} else {
					let acceptChatResult = await chatRef.update({
						last_updated: Math.floor(Date.now() / 1000),
						accepted: {status: 2, updated_at: Math.floor(Date.now() / 1000)}
					});
					console.log(acceptChatResult)

				}

			} catch (error) {
				console.log(error)
			}
		}
	};

	const toggleAttachments = () => {
		if (showAttachmentMenu === false) {
			return toggleAttachmentMenu(true)
		} else {
			return toggleAttachmentMenu(false)
		}
	}


	// handleImageUpdate = (e) => {
	// 	e.preventDefault()
	// 	const files = Array.from(e.target.files)
	// 	this.setState({image: files})
	// 	console.log(files[0])
	// }
	const sendMessage = async () => {
		const messages = message;
		updateMessage('')
		console.log('attempting send message')

		const {profile, firebase, selected} = props;
		let disabled = true
		if (messages !== '') {
			disabled = false
		}
		console.log(fileAttachment)
		if (fileAttachment && fileAttachment.length > 0) {
			disabled = false
		}
		if (disabled === false) {
			console.log('sending message')
			try {
				let chatRef = firebase.chat(selected.id);
				let has_attachment = false
				let attachment = null
				let attachmentType = null
				if (fileAttachment && fileAttachment.length > 0) {
					has_attachment = true
					attachmentType = 'file'
					const file = fileAttachment[0]
					const name = (+new Date()) + '-' + file.name;
					if (file.type[0] === 'i') {
						attachmentType = 'image'
					}
					const metadata = {
						contentType: file.type
					};
					let storageRef = firebase.storage.ref()
					const task = await storageRef.child(name).put(file, metadata)
					attachment = await task.ref.getDownloadURL()
					// console.log('attachemnt', attachment)
				}
				let newMessageResult = await chatRef.update({
					last_updated: Math.floor(Date.now() / 1000),
					messages: [...selected.messages, {
							uid: profile.id,
							message: messages,
							seen: [profile.id],
							created_at: Math.floor(Date.now() / 1000),
							has_attachment,
							attachment,
							attachment_type: attachmentType
						}
					],
					deleted: []
				});
				console.log(newMessageResult);
				handleFileUpload(null)
				toggleAttachmentMenu(false)
				// updatePreview(null)
			} catch (error) {
				console.log(error)
			}
		}

	};

	const isFaculty = (props) => {
		let isFacultyChecked = false;
		props.members.forEach(item => {
			if (item.id.length !== 7) {
				isFacultyChecked = true;
			}
		});

		return isFacultyChecked; 
	};

	const sendAttachment = async (files) => {
		console.log('attempting send message')

		const {profile, firebase, selected} = props;
		let disabled = false
		// if(message !== ''){
		// 	disabled = false
		// }
		// console.log(fileAttachment)
		// if(fileAttachment && fileAttachment.length > 0){
		// 	disabled = false
		// }
		if (disabled === false) {
			console.log('sending attachements')
			try {
				let chatRef = firebase.chat(selected.id);
				let has_attachment = false
				let attachment = null
				let attachmentType = null
				let fileName = ''
				if (files && files.length > 0) {
					has_attachment = true
					attachmentType = 'file'
					const file = files[0]
					const name = (+new Date()) + '-' + file.name;
					fileName = file.name

					if (file.type[0] === 'i') {
						attachmentType = 'image'
					}
					const metadata = {
						contentType: file.type
					};
					let storageRef = firebase.storage.ref()
					const task = await storageRef.child(name).put(file, metadata)
					attachment = await task.ref.getDownloadURL()
					// console.log('attachemnt', attachment)
				}
				let newMessageResult = await chatRef.update({
					last_updated: Math.floor(Date.now() / 1000),
					messages: firebase.fieldValue.arrayUnion({
							uid: profile.id,
							message,
							seen: [profile.id],
							created_at: Math.floor(Date.now() / 1000),
							has_attachment,
							attachment,
							attachment_type: attachmentType,
							file_name: fileName
						}
					)
				});
				console.log(newMessageResult);
				updateMessage('')
				handleFileUpload(null)
				// updatePreview(null)
			} catch (error) {
				console.log(error)
			}
		}

	};
	// const handleClearAttachemnts = () => {
	// 	handleFileUpload(null)
	// 	// updatePreview(null)
	// }

	const handleKeyPress = (event) => {
		if (event.key !== 'Enter') return;
		sendMessage();
	};

	const handleFile = async (e) => {
		e.preventDefault()
		const files = Array.from(e.target.files)
		handleFileUpload(files)
		toggleAttachments()

		console.log('sending')
		await sendAttachment(files)
		console.log('sent')
		//
		// let reader = new FileReader();
		// if (files && files.length > 0) {
		// 	let file = files[0];
		// 	// if(e.target.name === 'image'){
		// 	//
		// 	// }
		//
		// 	// reader.onloadend = () => {
		// 	// 	updatePreview(reader.result)
		// 	// }
		// 	// if(file.type[0] === 'i'){
		// 	// 	reader.readAsDataURL(file)
		// 	// }
		//
		// 	// toggleAttachments()
		// }


	}

	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			sendMessage();
			return true;
		}
	}


	const {selected, members, profile, isPopup} = props;
	let creator = members.filter(member => member.id === selected.creator_uid);
	let creatorName = '';
	if (creator.length > 0) {
		creatorName = creator[0].first_name + ' ' + creator[0].last_name
	}
	const others = members.filter(member => member.id !== selected.creator_uid || member.id !== profile.id);

	let acceptedList = []
	let acceptedNames = ''
	let hasNotAcceptedList = []
	let hasNotAcceptedNames = ''
	let isFacultyClicked = isFaculty(props);
	if(selected.is_group){
		if(selected.accepted.status !== 1) {


			acceptedList = others.filter(member => selected.accepted.members.includes(member.id))
			acceptedNames = acceptedList.map(member => `${member.first_name} ${member.last_name}`).join(', ').replace(/, ([^,]*)$/, ' and $1')
			hasNotAcceptedList = others.filter(member => !selected.accepted.members.includes(member.id))
			hasNotAcceptedNames = hasNotAcceptedList.map(member => `${member.first_name} ${member.last_name}`).join(', ').replace(/, ([^,]*)$/, ' and $1')
		}
		}
	const otherNames = others.map(member => `${member.first_name} ${member.last_name}`).join(', ').replace(/, ([^,]*)$/, ' and $1')
	const disableSend = message === ''
	return (
		<Box bg={'transparent'}>

			{selected.accepted.status !== 3 &&
			<CardWrapper width={'100%'} boxShadow={'main'} bg={'white'} p={0} m={0}>

				{selected.accepted.status === 1 ?
					// --------------------------------------------
					// Main Chat Message Input for accepted chats
					// --------------------------------------------
					<ToolbarWrapper>
						<Flex flexWrap={'wrap'} flexDirection={'row'}>


							<AttachmentWrapper pt={'4px'}>
								<Button bg={'white'} onClick={toggleAttachments} mr={2}
								        p={0}><Plus fontSize={'25px'}/></Button>
							</AttachmentWrapper>
							<InputWrapper pt={'4px'}>
							{
								isPopup ? 
									  <Input margin={0} padding={'10px'} onChange={handleInput} 
								       placeholder={'Type your message...'} value={message} onKeyPress={handleKeyPress} onKeyDown={handleKeyDown}/>
								:
									   <Input margin={0} padding={'10px'} onChange={handleInput} use={'textarea'} 
								       placeholder={'Type your message...'} value={message} onKeyPress={handleKeyPress} onKeyDown={handleKeyDown}/>
							}
							</InputWrapper>
							<ButtonWrapper pt={'4px'}>
								<SendButton variant='chatSend' bg={disableSend ? 'meta' : '#01795a'}
								            color={disableSend ? 'black' : 'white'} onClick={sendMessage} disabled={disableSend} mr={2}
								>Send</SendButton>
							</ButtonWrapper>


							{showAttachmentMenu &&
							<AttachementSection width={1} px={2} py={[1, 3]} boxShadow={['none', 'main']} bg="white">
								<Flex flexDirection={'column'}>
									<DesktopBox>
										<Text color='meta' pl={2}>Add a file from...</Text>
									</DesktopBox>

									<FileUpload handleFile={handleFile}/>
								</Flex>


							</AttachementSection>
							}
						</Flex>
					</ToolbarWrapper>
					:

					// --------------------------------------------
					// Messages and actions for new or unnacepted chats
					// --------------------------------------------
					<Box>
						{profile.id === selected.creator_uid ?


							// --------------------------------------------
							// Accepted/Declined Messages for Chat Creator/SENDER
							// --------------------------------------------

							(
								<Box>
									{selected.accepted.status === 0 &&
									<Fragment>
										{/* -----------------  */}
										{/* GROUP CHAT messages */}
										{/* ------------------- */}
										{selected.is_group ?
											<Fragment>
												{selected.accepted.members.length < 1 &&
												<Box>
												<Text p={3}>{isFacultyClicked ? 'Student to Faculty and ' : ''}Student to student chat requests are made to prevent potential harassment and
													cyberbullying. {hasNotAcceptedNames} have not accepted the request yet, please wait patiently
													for them to respond.</Text>
														{acceptedList.length > 0 &&
														<Text p={3}>{acceptedNames} has already accepted and can send and recieve messages.</Text>}
													</Box>}
												<ToolbarWrapper>
													<Flex flexWrap={'wrap'} flexDirection={'row'}>
														{/*<MobileBox >*/}
														{/*	{fileAttachment && <AttachementSection flexDirection={'column'}>*/}
														{/*		{imagePreview ?*/}
														{/*			<ImagePreview src={imagePreview} width={'auto'}/> :*/}
														{/*			<Text>{fileAttachment[0] && fileAttachment[0].name}</Text>*/}
														{/*		}*/}
														{/*		<Box>*/}
														{/*			<button onClick={handleClearAttachemnts}>Clear</button>*/}
														{/*		</Box>*/}
														{/*	</AttachementSection>}*/}
														{/*</MobileBox>*/}

														<AttachmentWrapper pt={'4px'}>
															<Button bg={'white'} onClick={toggleAttachments} mr={2}
															        p={0}><Plus fontSize={'25px'}/></Button>
														</AttachmentWrapper>
														<InputWrapper pt={'4px'}>
															<Input margin={0} padding={'10px'} onChange={handleInput}
															       placeholder={'Type your message...'} value={message} onKeyPress={handleKeyPress}/>
														</InputWrapper>
														<ButtonWrapper pt={'4px'}>
															<SendButton variant='chatSend' bg={disableSend ? 'meta' : '#01795a'}
															            color={disableSend ? 'black' : 'white'} onClick={sendMessage} disabled={disableSend} mr={2}
															>Send</SendButton>
														</ButtonWrapper>


														{showAttachmentMenu &&
														<AttachementSection width={1} px={2} py={[1, 3]} boxShadow={['none', 'main']} bg="white">
															<Flex flexDirection={'column'}>
																<DesktopBox>
																	<Text color='meta' pl={2}>Add a file from...</Text>
																</DesktopBox>
																<FileInputWrapper>
																	<Flex p={2}>
																		<Box>
																			<DesktopBox>
																				<LaptopIcon/>
																			</DesktopBox>
																			<MobileBox><Folder/></MobileBox>
																		</Box>
																		<Box>
																			<DesktopBox>

																				<Text pl={2} pt={'4px'} fontSize={'15px'}>Your Computer</Text>
																			</DesktopBox>
																			<MobileBox><Text textAlign='center' pl={2} pt={'4px'} fontSize={'15px'}>Attach a
																				file</Text></MobileBox>
																		</Box>
																	</Flex>
																	<input type="file" name="file" onChange={handleFile}/>

																</FileInputWrapper>
															</Flex>

															{/* Mobile Upload Buttons*/}
															{/*<MobileBox width={1}>*/}
															{/*	<Flex justifyContent={'centered'} flexDirection={'row'} flexWrap={'wrap'} width={1} p={2}>*/}


															{/*		<Box  width={1 / 2} p={2}>*/}

															{/*			<FileInputWrapper justifyContent={'center'} width={1}>*/}
															{/*				<Text textAlign={'center'}>*/}
															{/*				{!imagePreview &&*/}
															{/*				<Folder/>}*/}
															{/*				</Text>*/}
															{/*				<input type="file" name="file" accept="application/*" onChange={handleFile}/>*/}
															{/*			</FileInputWrapper>*/}
															{/*			<MetaText textAlign={'center'} p={2}>File</MetaText>*/}

															{/*		</Box>*/}
															{/*	</Flex>*/}
															{/*</MobileBox>*/}
														</AttachementSection>
														}
													</Flex>
												</ToolbarWrapper>
											</Fragment>
											:

											// --------------------------------------------
											// One To One Chat accepted messages
											// --------------------------------------------
											<Fragment>
												{
													selected.messages.length > 0 ?
														<Text p={3}> {isFacultyClicked ? 'Student to Faculty' : 'Student to Student'} chat requests are made to prevent potential harassment and
															cyberbullying. You have sent {others[0].first_name} a
															chat
															request, please wait patiently
															for {others[0].gender === 'M' ? 'him' : 'her'} to respond.</Text>
														:
														<Flex flexWrap={'wrap'} flexDirection={'row'}>
															<Text p={3}>You have started a new chat Request
																with {selected.is_group ? otherNames : `${others[0].first_name} ${others[0].last_name}`}.
																You may send one message while
																you wait for {selected.is_group ? 'them' : others[0].gender === 'M' ? 'him' : 'her'} to
																respond. </Text>
															<Box width={'80%'}>
																<Input margin={0} padding={'10px'} onChange={handleInput}
																       placeholder={'Type your message...'}
																       onKeyPress={handleKeyPress} value={message}/>
															</Box>
															<Box width={'20%'}>
																<Button bg={'white'} onClick={sendMessage} disabled={message === ''} mr={2}
																        p={0}><MetaText
																	p={2}>Send</MetaText></Button>
															</Box>
														</Flex>
												}
											</Fragment>
										}
									</Fragment>
									}
									{selected.accepted.status === 2 &&
									<Fragment>
										{moment().isSameOrAfter(moment.unix(selected.accepted.updated_at).add(1, 'd')) &&
										<Fragment>
											<Text p={3}>
												{others[0].first_name} {others[0].last_name} has declined your most recent chat request and you
												have been blocked from {others[0].gender === 'M' ? 'his' : 'her'} contacts. It has been more
												than
												24 hours since you're last request. Would you like to send another request?
											</Text>
											<Flex pb={2} justifyContent={'center'}>
												<Button variant={'approve'} onClick={handleSendAcceptRequest}>Yes</Button>
											</Flex>

										</Fragment>

										}
										{moment().isBefore(moment.unix(selected.accepted.updated_at).add(1, 'd')) &&
										<Text p={3}>
											{others[0].first_name} {others[0].last_name} has declined your most recent chat request and you
											have been blocked from {others[0].gender === 'M' ? 'his' : 'her'} contacts. You will be able to
											send {others[0].gender === 'M' ? 'him' : 'her'} another chat request
											in {moment(selected.accepted.status.updated_at).add(1, 'd').fromNow(true)}.
										</Text>}
									</Fragment>
									}
								</Box>
							) :


							// --------------------------------------------
							// Chat Accept/Decline Messages for the RECIEVER
							// --------------------------------------------

							(
								<Flex flexDirection={'column'} flexWrap={'wrap'}>
									{/*{selected.accepted.status === 2 ?*/}

									<Box>
										{selected.accepted.status === 0 ?
											<Fragment>
												{selected.is_group ?
													<Fragment>
														{selected.accepted.members.includes(profile.id) ?
															<ToolbarWrapper>
																<Flex flexWrap={'wrap'} flexDirection={'row'}>


																	<AttachmentWrapper pt={'4px'}>
																		<Button bg={'white'} onClick={toggleAttachments} mr={2}
																		        p={0}><Plus fontSize={'25px'}/></Button>
																	</AttachmentWrapper>
																	<InputWrapper pt={'4px'}>
																		<Input margin={0} padding={'10px'} onChange={handleInput}
																		       placeholder={'Type your message...'} value={message} onKeyPress={handleKeyPress}/>
																	</InputWrapper>
																	<ButtonWrapper pt={'4px'}>
																		<SendButton variant='chatSend' bg={disableSend ? 'meta' : '#01795a'}
																		            color={disableSend ? 'black' : 'white'} onClick={sendMessage} disabled={disableSend} mr={2}
																		>Send</SendButton>
																	</ButtonWrapper>


																	{showAttachmentMenu &&
																	<AttachementSection width={1} px={2} py={[1, 3]} boxShadow={['none', 'main']} bg="white">
																		<Flex flexDirection={'column'}>
																			<DesktopBox>
																				<Text color='meta' pl={2}>Add a file from...</Text>
																			</DesktopBox>
																			<FileInputWrapper>
																				<Flex p={2}>
																					<Box>
																						<DesktopBox>
																							<LaptopIcon/>
																						</DesktopBox>
																						<MobileBox><Folder/></MobileBox>
																					</Box>
																					<Box>
																						<DesktopBox>

																							<Text pl={2} pt={'4px'} fontSize={'15px'}>Your Computer</Text>
																						</DesktopBox>
																						<MobileBox><Text textAlign='center' pl={2} pt={'4px'} fontSize={'15px'}>Attach a
																							file</Text></MobileBox>
																					</Box>
																				</Flex>
																				<input type="file" name="file" onChange={handleFile}/>

																			</FileInputWrapper>
																		</Flex>

																	</AttachementSection>
																	}
																</Flex>
															</ToolbarWrapper>
															:
															< Flex justifyContent={'center'} flexDirection={'column'}  p={3}>
																<Box width={1}>
																<Text p={3}>
																	You have been invited to a group chat with {otherNames}. Would like to receive messages from now on? If you choose to
																	decline, you will be removed from the group.
																</Text>
																</Box>

																<Flex justifyContent={'center'} width={1}>
																<Button variant={['approve']} bg={'green'} onClick={handleAcceptChat}>Approve</Button>

																{selected.accepted.status === 0 &&
																<Button variant={'approve'} bg={'red'} onClick={handleDeclineChat}
																        ml={1}>Decline</Button>}

																</Flex>
															</Flex>
														}
													</Fragment>
													:
													<Fragment>
														<Text p={3}>
															Do you want to let {creatorName} send you messages from now on? If you choose to
															decline, {creatorName} will be blocked for 24 hours
															until {creator.length > 0 && creator[0].gender === 'M' ? 'he' : 'she'} has to request
															to chat
															with
															you again.
														</Text>
													</Fragment>
												}
											</Fragment>
											:
											<Text p={3}>
												{/* TODO: Countdown */}
												You have declined {creatorName}'s request to chat. {creatorName} will be unblocked
												in {moment(selected.accepted.status.updated_at).add(1, 'd').fromNow(true)}. If you
												wish to unblock {creator.length > 0 && creator[0].gender === 'M' ? 'him' : 'her'} now,
												you may Approve his chat request now.
											</Text>}
									</Box>
									{!selected.is_group &&
									< Flex justifyContent={'center'}>

										<Button variant={['approve']} bg={'green'} onClick={handleAcceptChat}>Approve</Button>

										{selected.accepted.status === 0 &&
										<Button variant={'approve'} bg={'red'} onClick={handleDeclineChat}
										        ml={1}>Decline</Button>}

									</Flex>}
								</Flex>
							)
						}

					</Box>

				}
			</CardWrapper>
			}
		</Box>
	);
};


export default withFirebase(InputToolbar);
